import { render, staticRenderFns } from "./OmxStatTile.vue?vue&type=template&id=6a1148a7&scoped=true"
import script from "./OmxStatTile.vue?vue&type=script&lang=js"
export * from "./OmxStatTile.vue?vue&type=script&lang=js"
import style0 from "./OmxStatTile.vue?vue&type=style&index=0&id=6a1148a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1148a7",
  null
  
)

export default component.exports